<template>
    <div></div>
</template>

<script>

export default {
    name: 'PageTypeDefault'
}
</script>